import { wsService } from "./wsService";
import sections from "@/constants/sections";

const section = sections.SECTION_SPENTS;

const STATE_VALID = 1;
//const STATE_PAID = 1;    
const STATE_CANCELED = 2;

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function create(params) {
  return wsService.make_post_request(section + "/create", params);
}

function update(params) {
  return wsService.make_post_request(section + "/update", params);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function get(id) {
  return wsService.make_get_request(section + "/get/" + id);
}

function cbteTiposInvoice(iva_condition, voucher_types) {
  return wsService.make_post_request(section + "/cbte_tipos", { iva_condition: iva_condition, voucher_types: voucher_types });
}

function getPendingSpents(params) {
  return wsService.make_post_request(section + "/get_pending_spents", params);
}

function getSpentAsoc(supplier, voucher_number, cbte_tipo, receiver) {
  return wsService.make_post_request(section + "/get_voucher_asoc", { supplier: supplier, voucher_number: voucher_number, cbte_tipo: cbte_tipo, receiver: receiver });
}

function export_filter(params) {
  return wsService.make_post_request(section + "/export", params, {
    responseType: "arraybuffer",
    headers: {
      Accept: "application/vnd.ms-excel",
    },
  });
}

function export_libro_iva_filter(params) {
  return wsService.make_post_request(section + "/export_libro_iva", params, {
    responseType: "arraybuffer",
    headers: {
      Accept: "application/vnd.ms-excel",
    },
  });
}

function getMonedas() {
  return [
    { Id: "PES", Desc: "ARS" },
    { Id: "USD", Desc: "USD" },
    { Id: "EUR", Desc: "EUR" },
  ];
}

function ivas() {
  return [
    { Id: null, Desc: "N/A" },
    { Id: 1, Desc: "No gravado" },
    { Id: 2, Desc: "Excento" },
    { Id: 3, Desc: "0%" },
    { Id: 9, Desc: "2.5%" },
    { Id: 8, Desc: "5%" },
    { Id: 4, Desc: "10.5%" },
    { Id: 5, Desc: "21%" },
    { Id: 6, Desc: "27%" },
  ];
}

function tributes() {
  return [
    { Id: 1, Desc: "Impuestos nacionales", jurisdiccion:false },
    { Id: 2, Desc: "Impuestos provinciales", jurisdiccion:true },
    { Id: 3, Desc: "Impuestos municipales", jurisdiccion:true },
    { Id: 4, Desc: "Impuestos internos", jurisdiccion:false },
    { Id: 99, Desc: "Impuestos otros", jurisdiccion:false },
    { Id: 5, Desc: "Impuestos IIBB", jurisdiccion:true },
    { Id: 6, Desc: "Percepcion IVA", jurisdiccion:false },
    { Id: 7, Desc: "Percepcion IIBB", jurisdiccion:true },
    { Id: 10, Desc: "Percepcion Ganancias", jurisdiccion:false },
    { Id: 8, Desc: "Percepcion Impuestos municipales", jurisdiccion:false },
    { Id: 9, Desc: "Percepcion otras", jurisdiccion:false },
    { Id: 13, Desc: "Percepcion IVA No categorizado", jurisdiccion:false },
  ];
}

function disassociate(spent_id, spent_asoc_id) {
  const params = { spent: spent_id, spent_asoc: spent_asoc_id };
  return wsService.make_post_request(section + "/disassociate", params);
}

function associate(spent_id, spent_asoc_id, imp_asoc = null) {
  const params = { spent: spent_id, spent_asoc: spent_asoc_id };
  if (imp_asoc != null) params.imp_asoc = imp_asoc;
  return wsService.make_post_request(section + "/associate", params);
}

function readInvoice(params) {
  return wsService.make_post_request(section + "/read-invoice", params);
}

function get_balances(params) {
  return wsService.make_post_request(section + "/get-balances", params);
}

function deleteComprobante(id) {
  return wsService.make_delete_request(section + "/delete-comprobante/" + id);
}

export const spentService = {
  filter,
  create,
  update,
  remove,
  getPendingSpents,
  getSpentAsoc,
  get,
  getMonedas,
  cbteTiposInvoice,
  ivas,
  tributes,
  export_filter,
  export_libro_iva_filter,
  disassociate,
  associate,
  readInvoice,
  get_balances,
  deleteComprobante,

  STATE_VALID,
  STATE_CANCELED,
};
